import List from "./List";
import Edit from "./Edit";
import Create from "./Create";
import { RoleIcon } from "../icons";
export default {
  options: {
    group: "admin",
    roles: ["admin"]
  },
  icon: RoleIcon,
  list: List,
  edit: Edit,
  create: Create
};
